import React, { Component } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'
import { Grid, Tab } from 'semantic-ui-react'
import { withRouter } from 'react-router-dom'

import utils from '../../utils'

import DriverList from '../../components/drivers/views/driversList'
import DriverAnalytics from '../../components/drivers/views/analytics'
import DriverSegments from '../../components/drivers/views/driverSegments'
import DriversBlock from '../../components/drivers/views/driversBlock'
import NonVerifyTransactions from './components/NonVerifyTransactions'

import DriverActions from '../../reducers/driverReducer'
import DriverSegmentActions from '../../reducers/driverSegmentReducer'

class Drivers extends Component {

  componentDidMount() {
    const { driverLoaded, driverSegmentLoaded, syncDrivers, syncDriverSegments, getNonVerifyTransactions } = this.props

    if (!driverLoaded) {
      syncDrivers()
    }

    if (!driverSegmentLoaded) {
      syncDriverSegments()
    }

    getNonVerifyTransactions()
  }

  renderDrivers = () => {
    const {
      user,
      drivers,
      history,
      saveDriver,
      deleteDriver,
      driverAdding,
      driverLoading,
      driverSegments,
      driverSegmentLoading,
      toggleDriverOnline,
    } = this.props

    return (
      <Tab.Pane color="black" attached={false} style={{ height: 'calc(100vh - 180px)' }}>
        <DriverList
          user={user}
          loading={driverLoading && driverSegmentLoading}
          driverSegments={driverSegments}
          driverAdding={driverAdding}
          drivers={drivers}
          deleteDriver={deleteDriver}
          saveDriver={saveDriver}
          history={history}
          toggleDriverOnline={toggleDriverOnline}
        />
      </Tab.Pane>
    )
  }

  renderAnalytics = () => {
    const {
      drivers,
      storeLoading,
      driverLoading,
      analyticOrders,
      analyticLoading,
      analyticDriverActivities,
      getAnalyticOrders,
    } = this.props

    return (
      <Tab.Pane color="black" attached={false} style={{ height: 'calc(100vh - 180px)' }}>
        <DriverAnalytics
          driverLoading={driverLoading || storeLoading}
          analyticLoading={analyticLoading}
          analyticOrders={analyticOrders}
          allActivities={analyticDriverActivities}
          drivers={drivers}
          getAnalyticOrders={getAnalyticOrders}
        />
      </Tab.Pane>
    )
  }

  renderDriverSegments = () => {
    const {
      driverSegments,
      addingDriverSegment,
      saveDriverSegment,
      driverSegmentLoading,
      deleteDriverSegment,
      history,
      drivers,
    } = this.props

    return (
      <Tab.Pane color="black" attached={false}>
        <DriverSegments
          addingDriverSegment={addingDriverSegment}
          drivers={drivers}
          driverSegments={driverSegments}
          saveDriverSegment={saveDriverSegment}
          deleteDriverSegment={deleteDriverSegment}
          loading={driverSegmentLoading}
          history={history}
        />
      </Tab.Pane>
    )
  }

  renderDriversBlock = () => {
    const { drivers, driverSegments, addingDriverSegment, user } = this.props

    return (
      <Tab.Pane color="black" attached={false}>
        <DriversBlock
          drivers={drivers}
          driverSegments={driverSegments}
          loading={addingDriverSegment}
          user={user}
        />
      </Tab.Pane>
    )
  }

  renderNonVerifyTransactions = () => {
    const { user, nonVerifyTransactions, getNonVerifyTransactions, gettingNonVerifyTransactions, setNonVerifyTransaction } = this.props

    return (
      <Tab.Pane color="black" attached={false}>
        <NonVerifyTransactions
          user={user}
          nonVerifyTransactions={nonVerifyTransactions}
          setNonVerifyTransaction={setNonVerifyTransaction}
          getNonVerifyTransactions={getNonVerifyTransactions}
          gettingNonVerifyTransactions={gettingNonVerifyTransactions}
        />
      </Tab.Pane>
    )
  }

  onTabChange = index => {
    const { history } = this.props
    const tabs = Object.keys(this.tabPanes())
    const queryString = tabs[index] ? `?tab=${tabs[index]}` : ''

    history.push(`/drivers${queryString}`)
  }

  tabPanes = () => {
    const { roles, user } = this.props
    const privileges = (roles[user.role] && roles[user.role].access) || []

    const tabs = {
      'drivers': {
        menuItem: 'Drivers', render: this.renderDrivers
      },
      'analytics': {
        menuItem: 'Analytics', render: this.renderAnalytics
      },
      'driver-segments': {
        menuItem: 'Driver Segments', render: this.renderDriverSegments
      },
      'blocking': {
        menuItem: 'Blocking', render: this.renderDriversBlock
      }
    }

    if (privileges.includes('non_verify_transactions'))
      tabs['non-verify-transactions'] = {
        menuItem: 'Non-Verify Transactions', render: this.renderNonVerifyTransactions
      }

    return tabs
  }

  render() {
    const params = utils.helpers.urlParams()
    const tab = params.tab || 'drivers'
    const tabIndex = Object.keys(this.tabPanes()).indexOf(tab)

    return (
      <div>
        <Grid>
          <Grid.Column width="16">
            <Tab
              activeIndex={tabIndex}
              menu={{ pointing: true }}
              panes={Object.values(this.tabPanes())}
              onTabChange={(e, { activeIndex }) => this.onTabChange(activeIndex)}
            />
          </Grid.Column>
        </Grid>
      </div>
    )
  }
}

const addDelivererNameToTransaction = (drivers, transactions) => {
  return _.map(transactions, transaction => {
    const familyName = _.get(drivers, [transaction.deliverer, 'family_name'], '')
    const firstName = _.get(drivers, [transaction.deliverer, 'first_name'], '')

    return {
      delivererName: `${familyName} ${firstName}`,
      ...transaction
    }
  })
}

const mapState = ({ drivers, driverSegments, auth, rolePermission }) => ({
  driverLoaded: drivers.driverLoaded,
  driverLoading: drivers.driverLoading,
  driverAdding: drivers.driverAdding,
  drivers: _.map(drivers.drivers, (driver, driverUID) => ({ ...driver, driverUID })),

  nonVerifyTransactionLoading: drivers.gettingNonVerifyTransactions,
  nonVerifyTransactions: addDelivererNameToTransaction(drivers.drivers, drivers.nonVerifyTransactions),

  analyticOrders: drivers.analyticOrders,
  analyticDriverActivities: drivers.analyticDriverActivities,
  analyticLoading: drivers.analyticLoading,

  driverSegments: driverSegments.driverSegments,
  addingDriverSegment: driverSegments.addingDriverSegment,
  driverSegmentLoaded: driverSegments.driverSegmentLoaded,
  driverSegmentLoading: driverSegments.driverSegmentLoading,

  roles: rolePermission.roles,
  user: auth.data,
})

const mapDispatch = {
  deleteDriver: DriverActions.deleteDriver,
  saveDriver: DriverActions.saveDriver,
  syncDrivers: DriverActions.syncDrivers,
  toggleDriverOnline: DriverActions.toggleDriverOnline,
  getAnalyticOrders: DriverActions.getAnalyticOrders,
  getNonVerifyTransactions: DriverActions.getNonVerifyTransactions,
  setNonVerifyTransaction: DriverActions.setNonVerifyTransaction,

  syncDriverSegments: DriverSegmentActions.syncDriverSegments,
  saveDriverSegment: DriverSegmentActions.saveDriverSegment,
  deleteDriverSegment: DriverSegmentActions.deleteDriverSegment,
}

export default connect(
  mapState,
  mapDispatch
)(withRouter(Drivers))



// WEBPACK FOOTER //
// ./src/containers/drivers/index.js